!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react-tv"), require("react")) : "function" == typeof define && define.amd ? define(["exports", "react-tv", "react"], t) : t(e.ReactTVNavigation = {}, e["react-tv"], e.React);
}(this, function (e, t, n) {
  "use strict";

  function r(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function o(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  t = t && t.hasOwnProperty("default") ? t.default : t, n = n && n.hasOwnProperty("default") ? n.default : n;
  var i = Object.getOwnPropertySymbols,
      u = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;

  var c = function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  }() ? Object.assign : function (e, t) {
    for (var n, r, o = function (e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    }(e), c = 1; c < arguments.length; c++) {
      for (var s in n = Object(arguments[c])) {
        u.call(n, s) && (o[s] = n[s]);
      }

      if (i) {
        r = i(n);

        for (var f = 0; f < r.length; f++) {
          a.call(n, r[f]) && (o[r[f]] = n[r[f]]);
        }
      }
    }

    return o;
  },
      s = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED",
      f = function f() {};

  if ("production" !== process.env.NODE_ENV) {
    var l = s,
        p = {};

    f = function f(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    };
  }

  var d = function d(e, t, n, r, o) {
    if ("production" !== process.env.NODE_ENV) for (var i in e) {
      if (e.hasOwnProperty(i)) {
        var u;

        try {
          if ("function" != typeof e[i]) {
            var a = Error((r || "React class") + ": " + n + " type `" + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[i] + "`.");
            throw a.name = "Invariant Violation", a;
          }

          u = e[i](t, i, r, n, null, l);
        } catch (e) {
          u = e;
        }

        if (!u || u instanceof Error || f((r || "React class") + ": type specification of " + n + " `" + i + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in p)) {
          p[u.message] = !0;
          var c = o ? o() : "";
          f("Failed " + n + " type: " + u.message + (null != c ? c : ""));
        }
      }
    }
  },
      v = function v() {};

  function h() {
    return null;
  }

  "production" !== process.env.NODE_ENV && (v = function v(e) {
    var t = "Warning: " + e;
    "undefined" != typeof console && console.error(t);

    try {
      throw new Error(t);
    } catch (e) {}
  });

  var y = function y(e, t) {
    var n = "function" == typeof Symbol && Symbol.iterator,
        r = "@@iterator";
    var o = "<<anonymous>>",
        i = {
      array: l("array"),
      bool: l("boolean"),
      func: l("function"),
      number: l("number"),
      object: l("object"),
      string: l("string"),
      symbol: l("symbol"),
      any: f(h),
      arrayOf: function arrayOf(e) {
        return f(function (t, n, r, o, i) {
          if ("function" != typeof e) return new a("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
          var u = t[n];

          if (!Array.isArray(u)) {
            var c = y(u);
            return new a("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected an array.");
          }

          for (var f = 0; f < u.length; f++) {
            var l = e(u, f, r, o, i + "[" + f + "]", s);
            if (l instanceof Error) return l;
          }

          return null;
        });
      },
      element: function () {
        return f(function (t, n, r, o, i) {
          var u = t[n];

          if (!e(u)) {
            var c = y(u);
            return new a("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected a single ReactElement.");
          }

          return null;
        });
      }(),
      instanceOf: function instanceOf(e) {
        return f(function (t, n, r, i, u) {
          if (!(t[n] instanceof e)) {
            var c = e.name || o,
                s = function (e) {
              if (!e.constructor || !e.constructor.name) return o;
              return e.constructor.name;
            }(t[n]);

            return new a("Invalid " + i + " `" + u + "` of type `" + s + "` supplied to `" + r + "`, expected instance of `" + c + "`.");
          }

          return null;
        });
      },
      node: function () {
        return f(function (e, t, n, r, o) {
          if (!p(e[t])) return new a("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
          return null;
        });
      }(),
      objectOf: function objectOf(e) {
        return f(function (t, n, r, o, i) {
          if ("function" != typeof e) return new a("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
          var u = t[n],
              c = y(u);
          if ("object" !== c) return new a("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected an object.");

          for (var f in u) {
            if (u.hasOwnProperty(f)) {
              var l = e(u, f, r, o, i + "." + f, s);
              if (l instanceof Error) return l;
            }
          }

          return null;
        });
      },
      oneOf: function oneOf(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && v("Invalid argument supplied to oneOf, expected an instance of array."), h;
        return f(function (t, n, r, o, i) {
          for (var c = t[n], s = 0; s < e.length; s++) {
            if (u(c, e[s])) return null;
          }

          var f = JSON.stringify(e);
          return new a("Invalid " + o + " `" + i + "` of value `" + c + "` supplied to `" + r + "`, expected one of " + f + ".");
        });
      },
      oneOfType: function oneOfType(e) {
        if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && v("Invalid argument supplied to oneOfType, expected an instance of array."), h;

        for (var t = 0; t < e.length; t++) {
          var n = e[t];
          if ("function" != typeof n) return v("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + g(n) + " at index " + t + "."), h;
        }

        return f(function (t, n, r, o, i) {
          for (var u = 0; u < e.length; u++) {
            var c = e[u];
            if (null == c(t, n, r, o, i, s)) return null;
          }

          return new a("Invalid " + o + " `" + i + "` supplied to `" + r + "`.");
        });
      },
      shape: function shape(e) {
        return f(function (t, n, r, o, i) {
          var u = t[n],
              c = y(u);
          if ("object" !== c) return new a("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");

          for (var f in e) {
            var l = e[f];

            if (l) {
              var p = l(u, f, r, o, i + "." + f, s);
              if (p) return p;
            }
          }

          return null;
        });
      },
      exact: function exact(e) {
        return f(function (t, n, r, o, i) {
          var u = t[n],
              f = y(u);
          if ("object" !== f) return new a("Invalid " + o + " `" + i + "` of type `" + f + "` supplied to `" + r + "`, expected `object`.");
          var l = c({}, t[n], e);

          for (var p in l) {
            var d = e[p];
            if (!d) return new a("Invalid " + o + " `" + i + "` key `" + p + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
            var v = d(u, p, r, o, i + "." + p, s);
            if (v) return v;
          }

          return null;
        });
      }
    };

    function u(e, t) {
      return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
    }

    function a(e) {
      this.message = e, this.stack = "";
    }

    function f(e) {
      if ("production" !== process.env.NODE_ENV) var n = {},
          r = 0;

      function i(i, u, c, f, l, p, d) {
        if (f = f || o, p = p || c, d !== s) {
          if (t) {
            var h = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
            throw h.name = "Invariant Violation", h;
          }

          if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
            var y = f + ":" + c;
            !n[y] && r < 3 && (v("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + f + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), n[y] = !0, r++);
          }
        }

        return null == u[c] ? i ? null === u[c] ? new a("The " + l + " `" + p + "` is marked as required in `" + f + "`, but its value is `null`.") : new a("The " + l + " `" + p + "` is marked as required in `" + f + "`, but its value is `undefined`.") : null : e(u, c, f, l, p);
      }

      var u = i.bind(null, !1);
      return u.isRequired = i.bind(null, !0), u;
    }

    function l(e) {
      return f(function (t, n, r, o, i, u) {
        var c = t[n];
        return y(c) !== e ? new a("Invalid " + o + " `" + i + "` of type `" + b(c) + "` supplied to `" + r + "`, expected `" + e + "`.") : null;
      });
    }

    function p(t) {
      switch (typeof t) {
        case "number":
        case "string":
        case "undefined":
          return !0;

        case "boolean":
          return !t;

        case "object":
          if (Array.isArray(t)) return t.every(p);
          if (null === t || e(t)) return !0;

          var o = function (e) {
            var t = e && (n && e[n] || e[r]);
            if ("function" == typeof t) return t;
          }(t);

          if (!o) return !1;
          var i,
              u = o.call(t);

          if (o !== t.entries) {
            for (; !(i = u.next()).done;) {
              if (!p(i.value)) return !1;
            }
          } else for (; !(i = u.next()).done;) {
            var a = i.value;
            if (a && !p(a[1])) return !1;
          }

          return !0;

        default:
          return !1;
      }
    }

    function y(e) {
      var t = typeof e;
      return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
        return "symbol" === e || "Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol;
      }(t, e) ? "symbol" : t;
    }

    function b(e) {
      if (void 0 === e || null === e) return "" + e;
      var t = y(e);

      if ("object" === t) {
        if (e instanceof Date) return "date";
        if (e instanceof RegExp) return "regexp";
      }

      return t;
    }

    function g(e) {
      var t = b(e);

      switch (t) {
        case "array":
        case "object":
          return "an " + t;

        case "boolean":
        case "date":
        case "regexp":
          return "a " + t;

        default:
          return t;
      }
    }

    return a.prototype = Error.prototype, i.checkPropTypes = d, i.PropTypes = i, i;
  };

  function b() {}

  var g = o(function (e) {
    if ("production" !== process.env.NODE_ENV) {
      var t = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103;
      e.exports = y(function (e) {
        return "object" == typeof e && null !== e && e.$$typeof === t;
      }, !0);
    } else e.exports = function () {
      function e(e, t, n, r, o, i) {
        if (i !== s) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t
      };
      return n.checkPropTypes = b, n.PropTypes = n, n;
    }();
  }),
      m = r(o(function (e, t) {
    t.__esModule = !0, t.default = function () {
      for (var e = arguments.length, t = Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      if (0 === t.length) return function (e) {
        return e;
      };
      if (1 === t.length) return t[0];
      return t.reduce(function (e, t) {
        return function () {
          return e(t.apply(void 0, arguments));
        };
      });
    };
  })),
      w = o(function (e, t) {
    t.__esModule = !0;

    t.default = function (e, t) {
      return function (n) {
        return n[e] = t, n;
      };
    };
  });
  r(w);
  var O = o(function (e, t) {
    t.__esModule = !0;
    var n,
        r = (n = w) && n.__esModule ? n : {
      default: n
    };

    t.default = function (e) {
      return (0, r.default)("displayName", e);
    };
  });
  r(O);
  var E = o(function (e, t) {
    t.__esModule = !0;

    t.default = function (e) {
      return "string" == typeof e ? e : e ? e.displayName || e.name || "Component" : void 0;
    };
  });
  r(E);

  var _ = o(function (e, t) {
    t.__esModule = !0;
    var n,
        r = (n = E) && n.__esModule ? n : {
      default: n
    };

    t.default = function (e, t) {
      return t + "(" + (0, r.default)(e) + ")";
    };
  });

  r(_);
  var P = r(o(function (e, t) {
    t.__esModule = !0;
    var r = i(O),
        o = i(_);

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.default = function (e) {
      return function (t) {
        var i = (0, n.createFactory)(t),
            u = function u(t) {
          return i(e(t));
        };

        return "production" !== process.env.NODE_ENV ? (0, r.default)((0, o.default)(t, "mapProps"))(u) : u;
      };
    };
  })),
      j = r(o(function (e, t) {
    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = u(O),
        i = u(_);

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.default = function (e) {
      return function (t) {
        var u = (0, n.createFactory)(t);
        "production" !== process.env.NODE_ENV && e.hasOwnProperty("render") && console.error("lifecycle() does not support the render method; its behavior is to pass all props and state to the base component.");

        var a = function (e) {
          function t() {
            return function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t), function (e, t) {
              if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }(this, e.apply(this, arguments));
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, e), t.prototype.render = function () {
            return u(r({}, this.props, this.state));
          }, t;
        }(n.Component);

        return Object.keys(e).forEach(function (t) {
          return a.prototype[t] = e[t];
        }), "production" !== process.env.NODE_ENV ? (0, o.default)((0, i.default)(t, "lifecycle"))(a) : a;
      };
    };
  })),
      I = r(o(function (e, t) {
    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = u(O),
        i = u(_);

    function u(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    t.default = function (e) {
      return function (t) {
        var u = (0, n.createFactory)(t),
            a = function a(e, t) {
          return u(r({}, e, t));
        };

        return a.contextTypes = e, "production" !== process.env.NODE_ENV ? (0, o.default)((0, i.default)(t, "getContext"))(a) : a;
      };
    };
  })),
      x = r(o(function (e, t) {
    t.__esModule = !0;
    var n,
        r = (n = w) && n.__esModule ? n : {
      default: n
    };

    t.default = function (e) {
      return (0, r.default)("propTypes", e);
    };
  })),
      F = o(function (e, t) {
    t.__esModule = !0;

    t.default = function (e, t) {
      var n = {};

      for (var r in e) {
        e.hasOwnProperty(r) && (n[r] = t(e[r], r));
      }

      return n;
    };
  });
  r(F);

  var T = r(o(function (e, t) {
    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = a(O),
        i = a(_),
        u = a(F);

    function a(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function c(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    t.default = function (e) {
      return function (t) {
        var a = (0, n.createFactory)(t),
            s = function (e) {
          function t() {
            var n, r;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t);

            for (var o = arguments.length, i = Array(o), u = 0; u < o; u++) {
              i[u] = arguments[u];
            }

            return n = r = c(this, e.call.apply(e, [this].concat(i))), f.call(r), c(r, n);
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, e), t.prototype.componentWillReceiveProps = function () {
            this.cachedHandlers = {};
          }, t.prototype.render = function () {
            return a(r({}, this.props, this.handlers));
          }, t;
        }(n.Component),
            f = function f() {
          var t = this;
          this.cachedHandlers = {}, this.handlers = (0, u.default)("function" == typeof e ? e(this.props) : e, function (e, n) {
            return function () {
              var r = t.cachedHandlers[n];
              if (r) return r.apply(void 0, arguments);
              var o = e(t.props);
              return t.cachedHandlers[n] = o, "production" !== process.env.NODE_ENV && "function" != typeof o && console.error("withHandlers(): Expected a map of higher-order functions. Refer to the docs for more info."), o.apply(void 0, arguments);
            };
          });
        };

        return "production" !== process.env.NODE_ENV ? (0, o.default)((0, i.default)(t, "withHandlers"))(s) : s;
      };
    };
  })),
      k = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  },
      S = {
    selector: "",
    straightOnly: !1,
    straightOverlapThreshold: .5,
    rememberSource: !1,
    disabled: !1,
    defaultElement: "",
    enterTo: "",
    leaveFor: null,
    restrict: "self-first",
    tabIndexIgnoreList: [],
    navigableFilter: null
  },
      N = {
    37: "left",
    38: "up",
    39: "right",
    40: "down"
  },
      B = {
    left: "right",
    up: "down",
    right: "left",
    down: "up"
  },
      M = "sn:",
      C = "section-",
      L = 0,
      D = !1,
      A = !1,
      H = {},
      R = 0,
      V = "",
      q = "",
      U = !1,
      z = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || function (e) {
    var t = (this.parentNode || this.document).querySelectorAll(e);
    return [].slice.call(t).indexOf(this) >= 0;
  };

  function K(e) {
    var t = e.getBoundingClientRect(),
        n = {
      left: t.left,
      top: t.top,
      right: t.right,
      bottom: t.bottom,
      width: t.width,
      height: t.height
    };
    return n.element = e, n.center = {
      x: n.left + Math.floor(n.width / 2),
      y: n.top + Math.floor(n.height / 2)
    }, n.center.left = n.center.right = n.center.x, n.center.top = n.center.bottom = n.center.y, n;
  }

  function W(e, t, n) {
    for (var r = [[], [], [], [], [], [], [], [], []], o = 0; o < e.length; o++) {
      var i,
          u,
          a = e[o],
          c = a.center;

      if (i = c.x < t.left ? 0 : c.x <= t.right ? 1 : 2, r[u = 3 * (c.y < t.top ? 0 : c.y <= t.bottom ? 1 : 2) + i].push(a), -1 !== [0, 2, 6, 8].indexOf(u)) {
        var s = n;
        a.left <= t.right - t.width * s && (2 === u ? r[1].push(a) : 8 === u && r[7].push(a)), a.right >= t.left + t.width * s && (0 === u ? r[1].push(a) : 6 === u && r[7].push(a)), a.top <= t.bottom - t.height * s && (6 === u ? r[3].push(a) : 8 === u && r[5].push(a)), a.bottom >= t.top + t.height * s && (0 === u ? r[3].push(a) : 2 === u && r[5].push(a));
      }
    }

    return r;
  }

  function Y(e, t, n, r) {
    if (!(e && t && n && n.length)) return null;

    for (var o = [], i = 0; i < n.length; i++) {
      var u = K(n[i]);
      u && o.push(u);
    }

    if (!o.length) return null;
    var a = K(e);
    if (!a) return null;

    var c,
        s = function (e) {
      return {
        nearPlumbLineIsBetter: function nearPlumbLineIsBetter(t) {
          var n;
          return (n = t.center.x < e.center.x ? e.center.x - t.right : t.left - e.center.x) < 0 ? 0 : n;
        },
        nearHorizonIsBetter: function nearHorizonIsBetter(t) {
          var n;
          return (n = t.center.y < e.center.y ? e.center.y - t.bottom : t.top - e.center.y) < 0 ? 0 : n;
        },
        nearTargetLeftIsBetter: function nearTargetLeftIsBetter(t) {
          var n;
          return (n = t.center.x < e.center.x ? e.left - t.right : t.left - e.left) < 0 ? 0 : n;
        },
        nearTargetTopIsBetter: function nearTargetTopIsBetter(t) {
          var n;
          return (n = t.center.y < e.center.y ? e.top - t.bottom : t.top - e.top) < 0 ? 0 : n;
        },
        topIsBetter: function topIsBetter(e) {
          return e.top;
        },
        bottomIsBetter: function bottomIsBetter(e) {
          return -1 * e.bottom;
        },
        leftIsBetter: function leftIsBetter(e) {
          return e.left;
        },
        rightIsBetter: function rightIsBetter(e) {
          return -1 * e.right;
        }
      };
    }(a),
        f = W(o, a, r.straightOverlapThreshold),
        l = W(f[4], a.center, r.straightOverlapThreshold);

    switch (t) {
      case "left":
        c = [{
          group: l[0].concat(l[3]).concat(l[6]),
          distance: [s.nearPlumbLineIsBetter, s.topIsBetter]
        }, {
          group: f[3],
          distance: [s.nearPlumbLineIsBetter, s.topIsBetter]
        }, {
          group: f[0].concat(f[6]),
          distance: [s.nearHorizonIsBetter, s.rightIsBetter, s.nearTargetTopIsBetter]
        }];
        break;

      case "right":
        c = [{
          group: l[2].concat(l[5]).concat(l[8]),
          distance: [s.nearPlumbLineIsBetter, s.topIsBetter]
        }, {
          group: f[5],
          distance: [s.nearPlumbLineIsBetter, s.topIsBetter]
        }, {
          group: f[2].concat(f[8]),
          distance: [s.nearHorizonIsBetter, s.leftIsBetter, s.nearTargetTopIsBetter]
        }];
        break;

      case "up":
        c = [{
          group: l[0].concat(l[1]).concat(l[2]),
          distance: [s.nearHorizonIsBetter, s.leftIsBetter]
        }, {
          group: f[1],
          distance: [s.nearHorizonIsBetter, s.leftIsBetter]
        }, {
          group: f[0].concat(f[2]),
          distance: [s.nearPlumbLineIsBetter, s.bottomIsBetter, s.nearTargetLeftIsBetter]
        }];
        break;

      case "down":
        c = [{
          group: l[6].concat(l[7]).concat(l[8]),
          distance: [s.nearHorizonIsBetter, s.leftIsBetter]
        }, {
          group: f[7],
          distance: [s.nearHorizonIsBetter, s.leftIsBetter]
        }, {
          group: f[6].concat(f[8]),
          distance: [s.nearPlumbLineIsBetter, s.topIsBetter, s.nearTargetLeftIsBetter]
        }];
        break;

      default:
        return null;
    }

    r.straightOnly && c.pop();

    var p = function (e) {
      for (var t = null, n = 0; n < e.length; n++) {
        if (e[n].group.length) {
          t = e[n];
          break;
        }
      }

      if (!t) return null;
      var r = t.distance;
      return t.group.sort(function (e, t) {
        for (var n = 0; n < r.length; n++) {
          var o = r[n],
              i = o(e) - o(t);
          if (i) return i;
        }

        return 0;
      }), t.group;
    }(c);

    if (!p) return null;
    var d = null;
    if (r.rememberSource && r.previous && r.previous.destination === e && r.previous.reverse === t) for (var v = 0; v < p.length; v++) {
      if (p[v].element === r.previous.target) {
        d = p[v].element;
        break;
      }
    }
    return d || (d = p[0].element), d;
  }

  function J(e) {
    return "string" == typeof e ? [].slice.call(document.querySelectorAll(e)) : "object" === (void 0 === e ? "undefined" : k(e)) && e.length ? [].slice.call(e) : "object" === (void 0 === e ? "undefined" : k(e)) && 1 === e.nodeType ? [e] : [];
  }

  function $(e, t) {
    return "string" == typeof t ? z.call(e, t) : "object" === (void 0 === t ? "undefined" : k(t)) && t.length ? t.indexOf(e) >= 0 : "object" === (void 0 === t ? "undefined" : k(t)) && 1 === t.nodeType && e === t;
  }

  function G() {
    var e = document.activeElement;
    if (e && e !== document.body) return e;
  }

  function Q(e) {
    e = e || {};

    for (var t = 1; t < arguments.length; t++) {
      if (arguments[t]) for (var n in arguments[t]) {
        arguments[t].hasOwnProperty(n) && void 0 !== arguments[t][n] && (e[n] = arguments[t][n]);
      }
    }

    return e;
  }

  function X(e, t) {
    Array.isArray(t) || (t = [t]);

    for (var n, r = 0; r < t.length; r++) {
      (n = e.indexOf(t[r])) >= 0 && e.splice(n, 1);
    }

    return e;
  }

  function Z(e, t, n) {
    if (!e || !t || !H[t] || H[t].disabled) return !1;
    if (e.offsetWidth <= 0 && e.offsetHeight <= 0 || e.hasAttribute("disabled")) return !1;
    if (n && !$(e, H[t].selector)) return !1;

    if ("function" == typeof H[t].navigableFilter) {
      if (!1 === H[t].navigableFilter(e, t)) return !1;
    } else if ("function" == typeof S.navigableFilter && !1 === S.navigableFilter(e, t)) return !1;

    return !0;
  }

  function ee(e) {
    for (var t in H) {
      if (!H[t].disabled && $(e, H[t].selector)) return t;
    }
  }

  function te(e) {
    return J(H[e].selector).filter(function (t) {
      return Z(t, e);
    });
  }

  function ne(e) {
    var t = H[e].defaultElement;
    return t ? ("string" == typeof t && (t = J(t)[0]), Z(t, e, !0) ? t : null) : null;
  }

  function re(e) {
    var t = H[e] && H[e].lastFocusedElement;
    return Z(t, e, !0) ? t : null;
  }

  function oe(e, t, n, r) {
    arguments.length < 4 && (r = !0);
    var o = document.createEvent("CustomEvent");
    return o.initCustomEvent(M + t, !0, r, n), e.dispatchEvent(o);
  }

  function ie(e, t, n) {
    if (!e) return !1;

    var r = G(),
        o = function o() {
      r && r.blur(), e.focus(), ue(e, t);
    };

    if (U) return o(), !0;
    if (U = !0, A) return o(), U = !1, !0;

    if (r) {
      var i = {
        nextElement: e,
        nextSectionId: t,
        direction: n,
        native: !1
      };
      if (!oe(r, "willunfocus", i)) return U = !1, !1;
      r.blur(), oe(r, "unfocused", i, !1);
    }

    var u = {
      previousElement: r,
      sectionId: t,
      direction: n,
      native: !1
    };
    return oe(e, "willfocus", u) ? (e.focus(), oe(e, "focused", u, !1), U = !1, ue(e, t), !0) : (U = !1, !1);
  }

  function ue(e, t) {
    t || (t = ee(e)), t && (H[t].lastFocusedElement = e, q = t);
  }

  function ae(e, t) {
    if ("@" == e.charAt(0)) {
      return 1 == e.length ? ce() : ce(e.substr(1));
    } else {
      var n = J(e)[0];

      if (n) {
        var r = ee(n);
        if (Z(n, r)) return ie(n, r, t);
      }
    }

    return !1;
  }

  function ce(e) {
    var t = [],
        n = function n(e) {
      e && t.indexOf(e) < 0 && H[e] && !H[e].disabled && t.push(e);
    };

    e ? n(e) : (n(V), n(q), Object.keys(H).map(n));

    for (var r = 0; r < t.length; r++) {
      var o,
          i = t[r];
      if (o = "last-focused" == H[i].enterTo ? re(i) || ne(i) || te(i)[0] : ne(i) || re(i) || te(i)[0]) return ie(o, i);
    }

    return !1;
  }

  function se(e, t) {
    oe(e, "navigatefailed", {
      direction: t
    }, !1);
  }

  function fe(e, t) {
    if (H[e].leaveFor && void 0 !== H[e].leaveFor[t]) {
      var n = H[e].leaveFor[t];
      if ("string" == typeof n) return "" === n ? null : ae(n, t);
      var r = ee(n);
      if (Z(n, r)) return ie(n, r, t);
    }

    return !1;
  }

  function le(e, t, n) {
    var r = t.getAttribute("data-sn-" + e);
    if ("string" == typeof r) return !("" === r || !ae(r, e)) || (se(t, e), !1);
    var o = {},
        i = [];

    for (var u in H) {
      o[u] = te(u), i = i.concat(o[u]);
    }

    var a,
        c = Q({}, S, H[n]);

    if ("self-only" == c.restrict || "self-first" == c.restrict) {
      var s = o[n];
      (a = Y(t, e, X(s, t), c)) || "self-first" != c.restrict || (a = Y(t, e, X(i, s), c));
    } else a = Y(t, e, X(i, t), c);

    if (a) {
      H[n].previous = {
        target: t,
        destination: a,
        reverse: B[e]
      };
      var f = ee(a);

      if (n != f) {
        var l,
            p = fe(n, e);
        if (p) return !0;
        if (null === p) return se(t, e), !1;

        switch (H[f].enterTo) {
          case "last-focused":
            l = re(f) || ne(f);
            break;

          case "default-element":
            l = ne(f);
        }

        l && (a = l);
      }

      return ie(a, f, e);
    }

    return !!fe(n, e) || (se(t, e), !1);
  }

  function pe(e) {
    if (!(!R || A || e.altKey || e.ctrlKey || e.metaKey || e.shiftKey)) {
      var t,
          n = function n() {
        return e.preventDefault(), e.stopPropagation(), !1;
      },
          r = N[e.keyCode];

      if (!r) return 13 == e.keyCode && (t = G()) && ee(t) && !oe(t, "enter-down") ? n() : void 0;
      if (!(t = G()) && (q && (t = re(q)), !t)) return ce(), n();
      var o = ee(t);
      if (o) return oe(t, "willmove", {
        direction: r,
        sectionId: o,
        cause: "keydown"
      }) && le(r, t, o), n();
    }
  }

  function de(e) {
    if (!(e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) && !A && R && 13 == e.keyCode) {
      var t = G();
      t && ee(t) && (oe(t, "enter-up") || (e.preventDefault(), e.stopPropagation()));
    }
  }

  function ve(e) {
    var t = e.target;

    if (t !== window && t !== document && R && !U) {
      var n = ee(t);

      if (n) {
        if (A) return void ue(t, n);
        var r = {
          sectionId: n,
          native: !0
        };
        oe(t, "willfocus", r) ? (oe(t, "focused", r, !1), ue(t, n)) : (U = !0, t.blur(), U = !1);
      }
    }
  }

  function he(e) {
    var t = e.target;

    if (t !== window && t !== document && !A && R && !U && ee(t)) {
      var n = {
        native: !0
      };
      oe(t, "willunfocus", n) ? oe(t, "unfocused", n, !1) : (U = !0, setTimeout(function () {
        t.focus(), U = !1;
      }));
    }
  }

  var ye = {
    init: function init() {
      D || (window.addEventListener("keydown", pe), window.addEventListener("keyup", de), window.addEventListener("focus", ve, !0), window.addEventListener("blur", he, !0), D = !0);
    },
    uninit: function uninit() {
      window.removeEventListener("blur", he, !0), window.removeEventListener("focus", ve, !0), window.removeEventListener("keyup", de), window.removeEventListener("keydown", pe), ye.clear(), L = 0, D = !1;
    },
    clear: function clear() {
      H = {}, R = 0, V = "", q = "", U = !1;
    },
    set: function set() {
      var e, t;
      if ("object" === k(arguments[0])) t = arguments[0];else {
        if ("string" != typeof arguments[0] || "object" !== k(arguments[1])) return;
        if (e = arguments[0], t = arguments[1], !H[e]) throw new Error('Section "' + e + "\" doesn't exist!");
      }

      for (var n in t) {
        void 0 !== S[n] && (e ? H[e][n] = t[n] : void 0 !== t[n] && (S[n] = t[n]));
      }

      e && (H[e] = Q({}, H[e]));
    },
    add: function add() {
      var e,
          t = {};
      if ("object" === k(arguments[0]) ? t = arguments[0] : "string" == typeof arguments[0] && "object" === k(arguments[1]) && (e = arguments[0], t = arguments[1]), e || (e = "string" == typeof t.id ? t.id : function () {
        for (var e; e = C + String(++L), H[e];) {
          ;
        }

        return e;
      }()), H[e]) throw new Error('Section "' + e + '" has already existed!');
      return H[e] = {}, R++, ye.set(e, t), e;
    },
    remove: function remove(e) {
      if (!e || "string" != typeof e) throw new Error('Please assign the "sectionId"!');
      return !!H[e] && (H[e] = void 0, H = Q({}, H), R--, !0);
    },
    disable: function disable(e) {
      return !!H[e] && (H[e].disabled = !0, !0);
    },
    enable: function enable(e) {
      return !!H[e] && (H[e].disabled = !1, !0);
    },
    pause: function pause() {
      A = !0;
    },
    resume: function resume() {
      A = !1;
    },
    focus: function focus(e, t) {
      var n = !1;
      void 0 === t && "boolean" == typeof e && (t = e, e = void 0);
      var r = !A && t;
      if (r && ye.pause(), e) {
        if ("string" == typeof e) n = H[e] ? ce(e) : ae(e);else {
          var o = ee(e);
          Z(e, o) && (n = ie(e, o));
        }
      } else n = ce();
      return r && ye.resume(), n;
    },
    move: function move(e, t) {
      if (e = e.toLowerCase(), !B[e]) return !1;
      var n = t ? J(t)[0] : G();
      if (!n) return !1;
      var r = ee(n);
      return !!r && !!oe(n, "willmove", {
        direction: e,
        sectionId: r,
        cause: "api"
      }) && le(e, n, r);
    },
    makeFocusable: function makeFocusable(e) {
      var t = function t(e) {
        var t = void 0 !== e.tabIndexIgnoreList ? e.tabIndexIgnoreList : S.tabIndexIgnoreList;
        J(e.selector).forEach(function (e) {
          $(e, t) || e.getAttribute("tabindex") || e.setAttribute("tabindex", "-1");
        });
      };

      if (e) {
        if (!H[e]) throw new Error('Section "' + e + "\" doesn't exist!");
        t(H[e]);
      } else for (var n in H) {
        t(H[n]);
      }
    },
    setDefaultSection: function setDefaultSection(e) {
      if (e) {
        if (!H[e]) throw new Error('Section "' + e + "\" doesn't exist!");
        V = e;
      } else V = "";
    },
    getSectionId: ee
  },
      be = function () {
    function e(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }();

  var ge = new (function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.handleFocused = this.handleFocused.bind(this), this.destroy(), this.bindFocusEvent();
    }

    return be(e, [{
      key: "init",
      value: function value(e) {
        this.setState || (this.setState = e), ye.init(), ye.focus(), this.bindFocusEvent();
      }
    }, {
      key: "destroy",
      value: function value() {
        this.focusedPath = null, this.setState = null, ye.uninit(), this.unbindFocusEvent();
      }
    }, {
      key: "bindFocusEvent",
      value: function value() {
        this.listening || (this.listening = !0, document.addEventListener("sn:focused", this.handleFocused));
      }
    }, {
      key: "unbindFocusEvent",
      value: function value() {
        document.removeEventListener("sn:focused", this.handleFocused), this.listening = !1;
      }
    }, {
      key: "handleFocused",
      value: function value(e) {
        this.focusedPath !== e.detail.sectionId && (this.setState(e.detail.sectionId), ye.focus(e.detail.sectionId));
      }
    }, {
      key: "getCurrentFocusedPath",
      value: function value() {
        return this.focusedPath;
      }
    }, {
      key: "setCurrentFocusedPath",
      value: function value(e) {
        this.focusedPath = e, ye.focus(e);
      }
    }, {
      key: "addFocusable",
      value: function value(e, t) {
        var n = t.focusPath,
            r = t.onEnterPressHandler;

        if (e && !ye.getSectionId(e)) {
          this.removeFocusable(e, {
            onEnterPressHandler: r
          });
          var o = [{
            selector: e
          }];
          n && o.unshift(n), e.addEventListener("sn:enter-down", r);
          var i = ye.add.apply(ye, o);
          ye.makeFocusable(i);
        }
      }
    }, {
      key: "removeFocusable",
      value: function value(e, t) {
        var n = t.onEnterPressHandler,
            r = ye.getSectionId(e);
        r && (ye.remove(r), e.removeEventListener("sn:enter-down", n));
      }
    }]), e;
  }())(),
      me = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var r in n) {
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
    }

    return e;
  };

  var we = m(x({
    focusPath: g.string.isRequired
  }), I({
    setFocus: g.func,
    currentFocusPath: g.string
  }), P(function (e) {
    var t = e.currentFocusPath,
        n = e.focusPath,
        r = e.setFocus,
        o = void 0 === r ? function () {} : r,
        i = function (e, t) {
      var n = {};

      for (var r in e) {
        t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
      }

      return n;
    }(e, ["currentFocusPath", "focusPath", "setFocus"]);

    return me({
      focused: t === n,
      setFocus: o.bind(null, n),
      focusPath: n
    }, i);
  }), T({
    onEnterPressHandler: function onEnterPressHandler(e) {
      var t = e.onEnterPress;
      return void 0 === t ? function () {} : t;
    }
  }), j({
    addFocusable: function addFocusable() {
      var e = this.props,
          n = e.focusPath,
          r = e.onEnterPressHandler;
      ge.addFocusable(t.findDOMNode(this), {
        focusPath: n,
        onEnterPressHandler: r
      });
    },
    componentDidMount: function componentDidMount() {
      this.addFocusable();
    },
    componentDidUpdate: function componentDidUpdate() {
      this.addFocusable();
    },
    componentWillUnmount: function componentWillUnmount() {
      ge.removeFocusable(t.findDOMNode(this), {
        onEnterPressHandler: this.props.onEnterPressHandler
      });
    }
  })),
      Oe = r(o(function (e, t) {
    t.__esModule = !0;
    var r = i(O),
        o = i(_);

    function i(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function u(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    t.default = function (e, t) {
      return function (i) {
        var a = (0, n.createFactory)(i),
            c = function (e) {
          function n() {
            var r, o;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, n);

            for (var i = arguments.length, a = Array(i), c = 0; c < i; c++) {
              a[c] = arguments[c];
            }

            return r = o = u(this, e.call.apply(e, [this].concat(a))), o.getChildContext = function () {
              return t(o.props);
            }, u(o, r);
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(n, e), n.prototype.render = function () {
            return a(this.props);
          }, n;
        }(n.Component);

        return c.childContextTypes = e, "production" !== process.env.NODE_ENV ? (0, r.default)((0, o.default)(i, "withContext"))(c) : c;
      };
    };
  })),
      Ee = Object.prototype.hasOwnProperty;

  function _e(e, t) {
    return e === t ? 0 !== e || 0 !== t || 1 / e == 1 / t : e != e && t != t;
  }

  var Pe = function Pe(e, t) {
    if (_e(e, t)) return !0;
    if ("object" != typeof e || null === e || "object" != typeof t || null === t) return !1;
    var n = Object.keys(e),
        r = Object.keys(t);
    if (n.length !== r.length) return !1;

    for (var o = 0; o < n.length; o++) {
      if (!Ee.call(t, n[o]) || !_e(e[n[o]], t[n[o]])) return !1;
    }

    return !0;
  },
      je = o(function (e, t) {
    t.__esModule = !0;
    var n,
        r = (n = Pe) && n.__esModule ? n : {
      default: n
    };
    t.default = r.default;
  });

  r(je);
  var Ie = m(r(o(function (e, t) {
    t.__esModule = !0;

    var r = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    },
        o = c(O),
        i = c(_),
        u = c(je),
        a = c(F);

    function c(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    function s(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }

    t.default = function (e, t) {
      return function (c) {
        var f = (0, n.createFactory)(c),
            l = function (e) {
          function t() {
            var n, r;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, t);

            for (var o = arguments.length, i = Array(o), u = 0; u < o; u++) {
              i[u] = arguments[u];
            }

            return n = r = s(this, e.call.apply(e, [this].concat(i))), p.call(r), s(r, n);
          }

          return function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
          }(t, e), t.prototype.shouldComponentUpdate = function (e, t) {
            var n = e !== this.props,
                r = !(0, u.default)(t, this.state);
            return n || r;
          }, t.prototype.render = function () {
            return f(r({}, this.props, this.state, this.stateUpdaters));
          }, t;
        }(n.Component),
            p = function p() {
          var n = this;
          this.state = "function" == typeof e ? e(this.props) : e, this.stateUpdaters = (0, a.default)(t, function (e) {
            return function (t) {
              for (var r = arguments.length, o = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) {
                o[i - 1] = arguments[i];
              }

              t && "function" == typeof t.persist && t.persist(), n.setState(function (n, r) {
                return e(n, r).apply(void 0, [t].concat(o));
              });
            };
          });
        };

        return "production" !== process.env.NODE_ENV ? (0, o.default)((0, i.default)(c, "withStateHandlers"))(l) : l;
      };
    };
  }))({
    currentFocusPath: ge.getCurrentFocusedPath()
  }, {
    setFocus: function setFocus(e) {
      var t = e.currentFocusPath;
      return function (e, n) {
        var r = n || e;
        if (t !== r) return ge.setCurrentFocusedPath(r), {
          currentFocusPath: r
        };
      };
    }
  }), Oe({
    setFocus: g.func,
    currentFocusPath: g.string
  }, function (e) {
    return {
      setFocus: e.setFocus,
      currentFocusPath: e.currentFocusPath
    };
  }), j({
    componentDidMount: function componentDidMount() {
      ge.init(this.props.setFocus);
    },
    componentDidUpdate: function componentDidUpdate() {
      ge.init(this.props.setFocus);
    },
    componentWillUnmount: function componentWillUnmount() {
      ge.destroy();
    }
  }));
  e.withFocusable = we, e.withNavigation = Ie, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});